import {UIGameChat} from './UIGameChat/UIGameChat'
import {UIGameLog} from './UIGameLog/UIGameLog'
import React, {useState} from 'react'
import styles from './UIGameFeeds.module.scss'
import {UIMutePlayerProvider} from '../../contexts/UIMutePlayerContext'
import clsx from 'clsx'
import {UIGameVoteContainer} from '../UIGameVote/UIGameVoteContainer'

export interface UIGameFeedsProps {
    isChatEnabled: boolean
    onClickLog: (logIndex: number) => void
    onSendChat: (message: string) => void
    isChatDefaultMinimized?: boolean
    className?: string
}

export function UIGameFeeds({
    isChatEnabled,
    onClickLog,
    onSendChat,
    isChatDefaultMinimized,
    className,
}: UIGameFeedsProps) {
    const [isLogVisible, setIsLogVisible] = useState(true)
    const [isChatVisible, setIsChatVisible] = useState(true)

    return (
        <UIMutePlayerProvider>
            <div className={clsx(styles.responsiveContainer, className)}>
                <UIGameVoteContainer className={styles.gameVoteContainer} setLogVisible={setIsLogVisible} setChatVisible={setIsChatVisible}/>
                <UIGameLog onClickLog={onClickLog} isLogVisible={isLogVisible} />
                {isChatEnabled && <UIGameChat
                    isChatVisible={isChatVisible}
                    isDefaultMinimized={isChatDefaultMinimized}
                    onSendChat={onSendChat}/>}
            </div>
        </UIMutePlayerProvider>
    )
}
